import { render, staticRenderFns } from "./RunItemDetails.vue?vue&type=template&id=4c457cce"
import script from "./RunItemDetails.vue?vue&type=script&lang=js"
export * from "./RunItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports